var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full relative"},[(_vm.renderer && _vm.camera)?_c('O3D',{},[_vm._t("default")],2):_vm._e(),_c('LoadingGUI')],1)}
var staticRenderFns = []

export { render, staticRenderFns }